export async function runWithConcurrency<T>(
  taskFactories: Array<() => Promise<T>>,
  limit: number
): Promise<T[]> {
  const results: T[] = [];
  let i = 0;
  const workers = new Array(Math.min(limit, taskFactories.length)).fill(0).map(async () => {
    while (i < taskFactories.length) {
      const idx = i++;
      results[idx] = await taskFactories[idx]();
    }
  });
  await Promise.all(workers);
  return results;
}
